import { useState } from 'react'

import { Icon, LinkIcon, UserMenuTopBar } from '@/components/core-v2'

import { PortfolioApprovalInfoModal } from './portfolio-approval-info-modal'

export const TopBarElement = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const onCloseModal = () => {
    setModalIsOpen(false)
  }

  const onOpenModal = () => {
    setModalIsOpen(true)
  }
  return (
    <>
      <UserMenuTopBar
        leftElement={
          <LinkIcon
            disabled={false}
            icon={<Icon name="circleInfo" size="default" />}
            iconPosition="left"
            text="Learn more about the portfolio approval process"
            onClick={onOpenModal}
          />
        }
      />
      {modalIsOpen && <PortfolioApprovalInfoModal onClose={onCloseModal} />}
    </>
  )
}
